import { render, staticRenderFns } from "./DocumentSummaryEditMenu.vue?vue&type=template&id=7564d267&scoped=true&"
import script from "./DocumentSummaryEditMenu.vue?vue&type=script&lang=ts&"
export * from "./DocumentSummaryEditMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSummaryEditMenu.vue?vue&type=style&index=0&id=7564d267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564d267",
  null
  
)

export default component.exports